enum FilterEvents {
  clickedFilterMenu = 'Clicked - Filter Menu',
  engagedFacet = 'Engaged - Facet',
  removedFilter = 'Removed - Filter',
  viewedFilterMenu = 'Viewed - Filter Menu'
}

export default FilterEvents;
